import { captureError } from "@/lib/errors/capture-error.ts";
import { ErrorBoundary, useErrorBoundary } from "react-error-boundary";
import { UnknownErrorMessage } from "./unknown-error-message";

export function GlobalErrorBoundary({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
}

function ErrorFallback({ error }: { error: Error }) {
  const { resetBoundary } = useErrorBoundary();

  captureError(error);

  return (
    <section className="flex flex-col items-center h-screen justify-center bg-gradient-to-b from-[rgba(222,245,79,0)] to-[rgba(222,245,79,0.4)]">
      <UnknownErrorMessage onReset={resetBoundary} />
    </section>
  );
}
